module.exports = __webpack_public_path__ + "img/uid-game-guide-2.b709da62.png";